import React, { useEffect, useRef } from 'react'
import FooterBG from "../../src/img/footerBG.avif"

function DownloadAfriPay() {
  const downloadRef = useRef(null);

  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry: any) => {
        if (entry.isIntersecting) {
          const elements = entry.target.querySelectorAll('.download-item')
          elements.forEach((element: any, index: any) => {
            setTimeout(() => {
              element.classList.add('animate-scale-in')
            }, index * 150)
          })
        }
      })
    }, observerOptions)

    if (downloadRef.current) {
      observer.observe(downloadRef.current)
    }

    return () => observer.disconnect()
  }, [])

  return (
    <>
      <style>{`
        @keyframes scaleIn {
          from {
            opacity: 0;
            transform: scale(0.95);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }

        .animate-scale-in {
          animation: scaleIn 0.8s ease-out forwards;
        }

        .initial-hidden {
          opacity: 0;
        }
      `}</style>

      <section className="w-full pt-10 md:pt-15 pb-6 px-8 lg:px-32 bg-[#001E0E]" ref={downloadRef}>
        <div className="max-w-6xl mx-auto">
          {/* White Container */}
          <div className="download-item initial-hidden rounded-3xl px-2 py-6 flex flex-col items-center text-base text-center" style={{ backgroundImage: `url(${FooterBG})`, backgroundRepeat: "no-repeat", backgroundSize: "cover", backgroundPosition: "center" }}>
            {/* Heading */}
            <h2 className="download-item initial-hidden font-display text-2xl md:text-4xl font-bold text-gray-900 mb-3 hidden lg:block">
              Join the Future of Borderless Payments
            </h2>
            <h2 className="download-item initial-hidden font-display text-2xl md:text-4xl font-bold text-gray-900 mb-3 block lg:hidden">
              Join the Future of Borderless Payments
            </h2>

            {/* Subheading */}
            <p className="download-item initial-hidden lg:text-lg text-[14px] mb-7">
              Manage all your Currencies, Cards, and transfers in one secure place.
            </p>

            <div className='flex flex-col md:flex-row items-center gap-3'>
              <input type="email" className='rounded-xl w-60 md:w-[315px] bg-white py-4 pl-4 text-base placeholder:text-[#637381] border border-[#A7E762]' placeholder='Enter your email address' />
              <button className='w-[78px] h-13 flex items-center justify-center text-white text-sm rounded-xl bg-[#0B7F47] border-2 border-[#7FBC51] p-3.5'>Submit</button>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default DownloadAfriPay